const state = {}

const getters = {
  paths: (state, getters, rootState) => {
    return rootState.route.path
  },
  params: (state, getters, rootState) => {
    return rootState.route.params
  },
  query: (state, getters, rootState) => {
    return rootState.route.query
  },
  matched: (state, getters, rootState) => {
    return rootState.route.matched
  },
}

const actions = {}

const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
